export const searchTranslations = {
    en: {
        pageTitle: "Search Results Page",
        metaDescription: "Qlik Search Results Page",
    },
    "de-DE": {
        pageTitle: "Such-Ergebnisse",
        metaDescription: "Die Seite mit den Ergebnissen Ihrer Qlik-Suche",
    },
    "fr-FR": {
        pageTitle: "Résultats de recherche",
        metaDescription: "Résultats de recherche Qlik",
    },
    "it-IT": {
        pageTitle: "Risultati della ricerca",
        metaDescription: "Pagina di risultati della ricerca di Qlik",
    },
    "es-ES": {
        pageTitle: "Página de resultados de búsqueda",
        metaDescription: "Página de resultados de búsqueda de Qlik",
    },
    "ja-JP": {
        pageTitle: "検索ページ",
        metaDescription: "検索ページ",
    },
    "pt-BR": {
        pageTitle: "Página de resultados de pesquisa",
        metaDescription: "Página de resultados de pesquisa da Qlik",
    },
};
